export default __webpack_public_path__ + "static/1258-4309aa86b42d5999f8c53c9bf4184b12.gif";